// 直销商城单个商品显示页面
<template>
  <div class="goods">
    <van-nav-bar
      :title="data.prod_name"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"/>
    <VipCarModel @pick="pickCarModel" />
    <van-tabs v-model="active" swipeable>
      <van-tab title="说明">
        <ProdImg :data="carImg" />
      </van-tab>
      <van-tab title="规格">
         <ProdSpc :data="data" />
      </van-tab>
    </van-tabs>

    <van-goods-action>
      <van-goods-action-icon icon="star" :text="hasFav?'已收藏':'待收藏'" :color="hasFav ? '#0050ff' : '#ff5000'" @click="favItem" />
      <van-goods-action-button color="#be99ff" type="warning" text="去收藏夹" @click="goFav" />
      <van-goods-action-button type="danger" @click="buyNow">
        立即购买
      </van-goods-action-button>
    </van-goods-action>
  </div>
</template>

<script>
import { DirectSellApi, DirectSellFavorites } from '@/api/directsell'
import { refreshAssert } from '@/utils/assert'
import VipCarModel from '@/view/components/vipcarmodel'
import ProdSpc from '@/view/directsell/components/prodspc'
import ProdImg from '@/view/directsell/components/prodimg'
import { setCurrentCar, getCars } from '@/utils/localutils'
import {
  Tag,
  Col,
  Icon,
  Cell,
  CellGroup,
  Swipe,
  Collapse,
  CollapseItem,
  List,
  Panel,
  NavBar,
  Tab,
  Tabs,
  SwipeItem,
  ActionSheet,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  // Toast
} from 'vant';

export default {
  components: {
    [Tag.name]: Tag,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Swipe.name]: Swipe,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [List.name]: List,
    [Panel.name]: Panel,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [SwipeItem.name]: SwipeItem,
    [NavBar.name]: NavBar,
    [ActionSheet.name]: ActionSheet,
    [GoodsAction.name]: GoodsAction,
    [GoodsActionIcon.name]: GoodsActionIcon,
    [GoodsActionButton.name]: GoodsActionButton,
    VipCarModel,
    ProdSpc,
    ProdImg
  },
  computed: {
    carImg () {
      if (this.curCar != null) {
        if (this.curCar.carcategory_id != null) {
          const models = this.imgs.filter((it) => it.car_model==this.curCar.carcategory_id)
          if (models.length > 0) {
            return models
          }
        }
        if (this.curCar.series_id != null) {
          const series = this.imgs.filter((it) => it.car_series==this.curCar.series_id)
          if (series.length >0) {
            return series
          }
        }
      }
      return this.imgs
    }
  },
  data() {
    return {
      id: this.$route.params.id,
      active: 0,
      curCar: null,
      imgs: [],// 直销图片介绍
      data: {
        prod_name: '',
        brand_name: '',
        spc: '',
        cls_name: '',
        cls1_name: '',
        barcode: '',
        shop_price: '',
        rem: '',
        images: [],
        versionprices: [],
        purposes: [],
        attributes: [],
        adapters: [],
        prod1_id: null,
        productversionprice1: null,
        cls: null,
        cls1: null,
        qty: 1
      },
      curversion: {
        id: null,
        name: '',
        price: null,
        cost: null,
        img: null,
        url: null
      }, // 当前版本
      hasFav: true
    };
  },
  mounted() {
    const car = getCars()
    this.curCar = car.curCar
    this.getData()
    
    refreshAssert()
  },
  methods: {
    getData() {
      var that = this
      this.axios.get(DirectSellApi + '/' + that.id + '/').then(function (ret) {
        that.data.prod_name = ret.car_products_name
        that.data.brand_name = ret.brand_name
        that.data.spc = ret.car_products_spc
        that.data.cls_name = ret.cls_name
        that.data.cls1_name = ret.cls1_name
        that.data.cls = ret.cls
        that.data.prod1_id = ret.prod1_id
        that.data.prod_id = ret.prod_id
        that.data.cls1 = ret.cls1
        that.data.barcode = ret.barcode
        that.data.shop_price = ret.shop_price
        that.data.rem = ret.rem
        that.data.images = ret.imagetext_values
        that.data.imgs = ret.imgs
        that.data.versionprices = ret.versionprice
        that.data.purposes = ret.purpose_values
        that.data.attributes = ret.attribute
        that.data.adapters = ret.adapter_values
        that.imgs = ret.imgs
        that.curversion = {
          id: ret.productversionprice1,
          name: ret.version_name,
          price: ret.price,
          cost: null,
          img: null,
          url: null
        }
        that.checkFav()
      }).catch(function (error) {
        console.log(error)
      })
    },
    checkFav() {
      const postData = {
        version: this.curversion.id
      }
      var that = this
      that.axios.get(DirectSellFavorites,{params: postData}).then(function (ret) {
        console.log(ret)
        that.hasFav = (ret.count>0)
      })
    },
    favItem() { // 收藏
      var that = this
      if (this.hasFav) {
        that.axios.delete(DirectSellFavorites + this.curversion.id + '/').then(function (ret) {
          if (ret.flag) {
            that.hasFav = false
          }
        })
      } else {
        const postData = {
          version: this.curversion.id,
          price: this.data.shop_price
        }
        that.axios.post(DirectSellFavorites,postData).then(function (ret) {
            if (ret.flag) {
              that.hasFav = true
            }
        })
      }
    },
    goFav() { // 去收藏夹
      this.$router.push(`/favorites`)
    },
    buyNow() { // 转到下单
      const data = {
        version_id: this.curversion.id,
        version_name: this.curversion.name,
        prd1_id: this.data.prod1_id,
        prd_name: this.data.prod_name,
        prd_spc: this.data.spc,
        prd_barcode: this.data.barcode,
        cls: this.data.cls,
        cls1: this.data.cls1,
        cls_name: this.data.cls_name,
        cls1_name: this.data.cls1_name,
        brand_name: this.data.brand_name,
        qty: this.data.qty,
        shop_price: this.data.shop_price,
        img: this.curversion.url
      }
      this.$router.push({
        name: 'nt/directsell/order', // 确定下单
        query: JSON.stringify(data)
      })
    },
    onClickLeft() {
      this.$router.back(-1)
    },
    pickCarModel(item) {
        this.curCar = item
        setCurrentCar(item)
        this.getData()
    },
  }
};
</script>

<style lang="less">
.goods {
  padding-bottom: 50px;

  &-swipe {
    img {
      width: 100%;
      display: block;
    }
  }

  &-title {
    font-size: 16px;
  }

  &-price {
    color: #f44;
  }

  &-express {
    color: #999;
    font-size: 12px;
    padding: 5px 15px;
  }

  &-cell-group {
    margin: 15px 0;

    .van-cell__value {
      color: #999;
    }
  }

  &-tag {
    margin-left: 5px;
  }
}
</style>
